import { EventLibrary } from "../eventTypes";
import { FunctionConfig } from "../functions/types";
import { TransformationOperationType } from "../transforms/types";
import { DestinationConnectionMode } from "../types/global";
import { CustomDestinationConfig } from "./configs/custom/types";

export type WarehouseDestinationSlug =
  | "azure"
  | "bigquery"
  | "databricks"
  | "panoply"
  | "postgres"
  | "redshift"
  | "s3"
  | "snowflake";

export type WarehouseDestinationKey =
  | "Azure"
  | "BigQuery"
  | "Databricks"
  | "Panoply"
  | "Postgres"
  | "Redshift"
  | "S3"
  | "Snowflake";

export type SaaSDestinationSlug =
  | "2mee"
  | "ab-smartly"
  | "active-campaign"
  | "adikteev"
  | "adlearn-open-platform"
  | "adobe-analytics"
  | "adquick"
  | "adroll"
  | "adtriba"
  | "airship"
  | "alexa"
  | "algolia-insights"
  | "amazon-eventbridge"
  | "amazon-kinesis"
  | "amazon-kinesis-firehose"
  | "amazon-lambda"
  | "amazon-personalize"
  | "ambassador"
  | "amplitude"
  | "anodot"
  | "appboy"
  | "appcues"
  | "appnexus"
  | "appsflyer"
  | "apptimize"
  | "apteligent"
  | "asayer"
  | "atatus"
  | "attribution"
  | "auryc"
  | "autopilothq"
  | "basis"
  | "batch"
  | "beamer"
  | "bime-analytics"
  | "bing-ads"
  | "blendo"
  | "blueshift"
  | "branch-metrics"
  | "bronto"
  | "bucket"
  | "bugherd"
  | "bugsnag"
  | "button"
  | "buzzboard"
  | "bytegain"
  | "calixa"
  | "callingly"
  | "calq"
  | "candu"
  | "canny"
  | "castle"
  | "chameleon"
  | "chartbeat"
  | "chartio"
  | "churnzero"
  | "clearbit-enrichment"
  | "clearbrain"
  | "clevertap"
  | "clicky"
  | "clientsuccess"
  | "cliff"
  | "comscore"
  | "convertflow"
  | "convertro"
  | "countly"
  | "courier"
  | "crazy-egg"
  | "crisp"
  | "criteo"
  | "crowdpower"
  | "cruncher"
  | "custify"
  | "customer-io"
  | "customersuccessbox"
  | "customfit-ai"
  | "data-lakes"
  | "delighted"
  | "digioh"
  | "dreamdata-io"
  | "drift"
  | "drip"
  | "elevio"
  | "email-aptitude"
  | "emarsys"
  | "emma"
  | "enjoyhq"
  | "epica"
  | "errorception"
  | "everflow"
  | "experiments-by-growthhackers"
  | "exponea"
  | "extole"
  | "facebook-conversions-api"
  | "facebook-custom-audiences"
  | "facebook-pixel"
  | "facebook-pixel-proxy"
  | "factorsai"
  | "firebase"
  | "floodlight"
  | "flurry"
  | "foxmetrics"
  | "freshmarketer"
  | "freshsales"
  | "friendbuy"
  | "full-story"
  | "funnelenvy"
  | "funnelfox"
  | "gainsight-cs"
  | "gainsight-px"
  | "gameball"
  | "gist"
  | "go-squared"
  | "goedle"
  | "google-ads"
  | "google-ads-conversion-api"
  | "google-ads-remarketing-lists"
  | "google-analytics"
  | "google-analytics-4"
  | "google-analytics-4-proxy"
  | "google-cloud-function"
  | "google-cloud-storage"
  | "google-display-360"
  | "google-pubsub"
  | "google-tag-manager"
  | "hasoffers"
  | "hawkei"
  | "headsup-ai"
  | "heap"
  | "hello-bar"
  | "help-scout"
  | "hittail"
  | "hotjar"
  | "hubspot"
  | "hubspot-cloud"
  | "hull"
  | "hydra"
  | "ibm-universal-behavior-exchange"
  | "impactdotcom"
  | "improvely"
  | "indicative"
  | "inkit"
  | "insider"
  | "inspectlet"
  | "interana"
  | "intercom"
  | "iron-io"
  | "iterable"
  | "jackdb"
  | "journy-io"
  | "june"
  | "kahuna"
  | "kameleoon"
  | "keen"
  | "kevel"
  | "kissmetrics"
  | "kitemetrics"
  | "klaviyo"
  | "kubit"
  | "kustomer"
  | "lantern"
  | "launchdarkly-events"
  | "lead-squared"
  | "leanplum"
  | "learndot"
  | "librato"
  | "linkedin-tag"
  | "linkedin-ads"
  | "live-chat"
  | "localytics"
  | "lou"
  | "lucky-orange"
  | "lytics"
  | "mabl"
  | "madkudu"
  | "mailchimp"
  | "mailjet"
  | "mammoth"
  | "marketo"
  | "markettailor"
  | "matomo"
  | "mediamath"
  | "metacx"
  | "millennial-media"
  | "mixpanel"
  | "mode"
  | "modern-pricing"
  | "moengage"
  | "moesif-api-analytics"
  | "monetate"
  | "moosend"
  | "mouseflow"
  | "mousestats"
  | "movable-ink"
  | "msg91"
  | "mutiny"
  | "nanigans"
  | "nat"
  | "natero"
  | "navilytics"
  | "new-relic-insights"
  | "nielsen-dcr"
  | "noora"
  | "nudgespot"
  | "olark"
  | "one-signal"
  | "optimizely-x"
  | "oracle-eloqua"
  | "pardot-by-salesforce"
  | "parsely"
  | "pendo"
  | "perfect-audience"
  | "periscope-data"
  | "perkville"
  | "persistiq"
  | "personyze"
  | "pingdom"
  | "pinterest-ads"
  | "pinterest-tag"
  | "pixelme"
  | "planhat"
  | "podsights"
  | "pointillist"
  | "posthog"
  | "productbird"
  | "profitwell"
  | "promoter-io"
  | "proof-experiences"
  | "prosperstack"
  | "qualaroo"
  | "quantcast"
  | "quora-conversion-pixel"
  | "radiumone-connect"
  | "ramen"
  | "recombee-ai"
  | "reddit-ads"
  | "refersion"
  | "refiner"
  | "repeater"
  | "replay-bird"
  | "responsys"
  | "retently"
  | "retina"
  | "richpanel"
  | "rockerbox"
  | "rollbar"
  | "sailthru-v2"
  | "salescamp-crm"
  | "salesforce"
  | "salesmachine"
  | "satis-meter"
  | "savio"
  | "scopeai"
  | "screeb"
  | "seg"
  | "segmetrics"
  | "selligent-marketing-cloud"
  | "sendinblue"
  | "sentry"
  | "serenytics"
  | "shareasale"
  | "sherlock"
  | "simplereach"
  | "singular"
  | "slack"
  | "slicingdice"
  | "smartlook"
  | "snap-engage"
  | "snapboard"
  | "snapchat-audiences"
  | "spinnakr"
  | "split"
  | "stackadapt"
  | "startdeliver"
  | "statsig"
  | "stitch"
  | "stonly"
  | "stories"
  | "stormly"
  | "strikedeck"
  | "survicate"
  | "swrve"
  | "tableau"
  | "talkable"
  | "talon-one"
  | "tamber"
  | "taplytics"
  | "tapstream"
  | "thetradedesk"
  | "tiktok-ads"
  | "totango"
  | "track-js"
  | "tractionboard"
  | "trafficguard"
  | "tray-io"
  | "treasure-data"
  | "trustpilot"
  | "tune"
  | "tv-squared"
  | "twitter-ads"
  | "unwaffle"
  | "upcall"
  | "user-com"
  | "useriq"
  | "userleap"
  | "userlike"
  | "userlist"
  | "userpilot"
  | "uservoice"
  | "variance"
  | "vero"
  | "vespucci"
  | "vidora"
  | "vitally"
  | "voucherify"
  | "vwo"
  | "walkme"
  | "web-engage"
  | "webhooks"
  | "whale-watch"
  | "whalr"
  | "wigzo"
  | "wishpond"
  | "woopra"
  | "xplenty"
  | "xtremepush"
  | "yandex-metrica"
  | "youbora"
  | "zaius"
  | "zapier"
  | "zendesk";

export type FunctionSlug = string;

export type SaaSDestinationKey =
  | "2mee"
  | "AB Smartly"
  | "ActiveCampaign"
  | "Adikteev"
  | "Adjust"
  | "AdLearn Open Platform"
  | "Adobe Analytics"
  | "Adobe Video Heartbeat"
  | "AdQuick"
  | "AdRoll"
  | "AdobeAnalytics"
  | "Adtriba"
  | "Airship"
  | "Alexa"
  | "Algolia Insights"
  | "Amazon EventBridge"
  | "Amazon Kinesis Firehose"
  | "Amazon Kinesis"
  | "Amazon Lambda"
  | "Amazon Personalize"
  | "Amazon S3"
  | "Ambassador"
  | "Amplitude"
  | "Anodot"
  | "Appboy"
  | "Appcues"
  | "AppNexus"
  | "AppsFlyer"
  | "Apptimize"
  | "Apteligent"
  | "Asayer"
  | "Atatus"
  | "Attribution"
  | "Auryc"
  | "AutopilotHQ"
  | "AWS S3"
  | "Azure Function"
  | "Basis"
  | "Batch"
  | "Beamer"
  | "BIME Analytics"
  | "Bing Ads"
  | "Blendo"
  | "Blueshift"
  | "Boomtrain"
  | "Branch Metrics"
  | "Braze"
  | "Bronto"
  | "Bucket"
  | "BugHerd"
  | "Bugsnag"
  | "Button"
  | "BuzzBoard"
  | "ByteGain"
  | "BytePlus"
  | "Calixa"
  | "Callingly"
  | "Calq"
  | "Candu"
  | "Canny"
  | "Castle"
  | "Chameleon"
  | "Chartbeat"
  | "Chartio"
  | "ChurnZero"
  | "Clearbit Enrichment"
  | "Clearbit Reveal"
  | "ClearBrain"
  | "CleverTap"
  | "Clicky"
  | "ClientSuccess"
  | "Cliff"
  | "comScore"
  | "ConvertFlow"
  | "Convertro"
  | "Countly"
  | "Courier"
  | "Crazy Egg"
  | "Crisp"
  | "Criteo Offline Conversions"
  | "Criteo"
  | "CrowdPower"
  | "Cruncher"
  | "Custify"
  | "Customer.io"
  | "CustomerSuccessBox"
  | "CustomFit.ai"
  | "Data Lakes"
  | "DataBrain"
  | "Delighted"
  | "Digioh"
  | "Dreamdata IO"
  | "Drift"
  | "Drip"
  | "Elevio"
  | "Email Aptitude"
  | "Emarsys"
  | "EMMA"
  | "EnjoyHQ"
  | "EPICA"
  | "Errorception"
  | "Everflow"
  | "Experiments by Growthhackers"
  | "Exponea"
  | "Extole"
  | "Facebook App Events"
  | "Facebook Conversions API"
  | "Facebook Custom Audiences"
  | "Facebook Offline Conversions"
  | "Facebook Pixel"
  | "Facebook Pixel Proxy"
  | "FactorsAI"
  | "Firebase"
  | "Floodlight"
  | "Flurry"
  | "FoxMetrics"
  | "Freshmarketer"
  | "Freshsales"
  | "Friendbuy"
  | "FullStory"
  | "FunnelEnvy"
  | "FunnelFox"
  | "Gainsight CS"
  | "Gainsight PX"
  | "Gameball"
  | "Gauges"
  | "Gist"
  | "Goedle"
  | "Google Ads (Gtag)"
  | "Google Ads Conversion API"
  | "Google Ads Remarketing Lists"
  | "Google AdWords New"
  | "Google AdWords Remarketing Lists (Customer Match)"
  | "Google Analytics 4 Proxy"
  | "Google Analytics 4"
  | "Google Analytics"
  | "Google Cloud Function"
  | "Google Cloud Storage"
  | "Google Display 360"
  | "Google PubSub"
  | "Google Tag Manager"
  | "GoSquared"
  | "HasOffers"
  | "Hawkei"
  | "HeadsUp AI"
  | "Heap"
  | "Hello Bar"
  | "Help Scout"
  | "HitTail"
  | "Hotjar"
  | "HubSpot Cloud"
  | "HubSpot"
  | "Hull"
  | "Hydra"
  | "IBM Universal Behavior Exchange"
  | "impactdotcom"
  | "Improvely"
  | "Indicative"
  | "Inkit"
  | "Insider"
  | "Inspectlet"
  | "Interana"
  | "Intercom"
  | "Iron.io"
  | "Iterable"
  | "JackDB"
  | "journy io"
  | "June"
  | "Kahuna"
  | "Kameleoon"
  | "Keen IO"
  | "Kevel"
  | "KISSmetrics"
  | "Kitemetrics"
  | "Klaviyo"
  | "Kochava"
  | "Kubit"
  | "Kustomer"
  | "Lantern"
  | "LaunchDarkly Events"
  | "LeadSquared"
  | "Leanplum"
  | "Learndot"
  | "Librato"
  | "LinkedIn Insight Tag"
  | "linkedin-ads"
  | "LiveChat"
  | "Localytics"
  | "Lou"
  | "Lucky Orange"
  | "Lytics"
  | "mabl"
  | "MadKudu"
  | "Mailchimp"
  | "Mailjet"
  | "Mammoth"
  | "Marketo Static Lists"
  | "Marketo"
  | "Markettailor"
  | "Matomo"
  | "MediaMath"
  | "MetaCX"
  | "Millennial Media"
  | "Mixpanel"
  | "Mode"
  | "Modern Pricing"
  | "MoEngage"
  | "Moesif API Analytics"
  | "Monetate"
  | "Moosend"
  | "Mouseflow"
  | "MouseStats"
  | "Movable Ink"
  | "MSG91"
  | "Mutiny"
  | "Nanigans"
  | "Nat"
  | "Natero"
  | "Navilytics"
  | "New Relic Insights"
  | "Nielsen DCR"
  | "Noora"
  | "Nudgespot"
  | "Olark"
  | "OneSignal"
  | "Optimizely Web"
  | "Optimizely X"
  | "Oracle Eloqua"
  | "Pardot by Salesforce"
  | "Parsely"
  | "Pendo"
  | "Perfect Audience"
  | "Periscope Data"
  | "Perkville"
  | "PersistIQ"
  | "Personyze"
  | "Pingdom"
  | "pinterest-ads"
  | "Pinterest Audiences"
  | "Pinterest Tag"
  | "PixelMe"
  | "Planhat"
  | "Podsights"
  | "Pointillist"
  | "PostHog"
  | "ProductBird"
  | "ProfitWell"
  | "Promoter.io"
  | "Proof Experiences"
  | "ProsperStack"
  | "Qualaroo"
  | "Quantcast"
  | "Quanticmind"
  | "Quora Conversion Pixel"
  | "RadiumOne Connect"
  | "Ramen"
  | "Recombee AI"
  | "reddit-ads"
  | "Refersion"
  | "Refiner"
  | "Refiner-Stream"
  | "Regal Voice"
  | "Repeater"
  | "ReplayBird"
  | "Responsys"
  | "Retently"
  | "Retina"
  | "Richpanel"
  | "Rockerbox"
  | "Rollbar"
  | "Sailthru v2"
  | "Salescamp CRM"
  | "Salesforce Marketing Cloud"
  | "Salesforce"
  | "Salesmachine"
  | "SatisMeter"
  | "Savio"
  | "ScopeAi"
  | "Screeb"
  | "Seg"
  | "SegMetrics"
  | "Selligent Marketing Cloud"
  | "Sendinblue"
  | "Sentry"
  | "Serenytics"
  | "ShareASale"
  | "Sherlock"
  | "SIGNL4 Alerting"
  | "SimpleReach"
  | "Singular"
  | "Slack"
  | "SlicingDice"
  | "Smartlook"
  | "Snapboard"
  | "Snapchat Audiences"
  | "SnapEngage"
  | "Spinnakr"
  | "Split"
  | "StackAdapt"
  | "Startdeliver"
  | "Statsig"
  | "Stitch"
  | "Stonly"
  | "Stories"
  | "Stormly"
  | "Strikedeck"
  | "Survicate"
  | "Swrve"
  | "Tableau"
  | "Talkable"
  | "Talon.One"
  | "Tamber"
  | "Taplytics"
  | "Tapstream"
  | "theTradeDesk"
  | "TikTok Ads"
  | "Totango"
  | "Track JS"
  | "Tractionboard"
  | "TrafficGuard"
  | "Tray.io"
  | "Treasure Data"
  | "Trustpilot"
  | "TUNE"
  | "TV Squared"
  | "Twitter Ads"
  | "Unwaffle"
  | "Upcall"
  | "User.com"
  | "UserIQ"
  | "UserLeap"
  | "Userlike"
  | "Userlist"
  | "Userpilot"
  | "UserVoice"
  | "Variance"
  | "Vero"
  | "Vespucci"
  | "Vidora"
  | "Vimeo"
  | "Vitally"
  | "Voucherify"
  | "VWO"
  | "WalkMe"
  | "Watsi"
  | "WebEngage"
  | "Webhooks"
  | "Whale Watch"
  | "Whalr"
  | "Wigzo"
  | "Wishpond"
  | "Woopra"
  | "Xplenty"
  | "Xtremepush"
  | "Yandex Metrica"
  | "YellowHammer"
  | "Youbora"
  | "Zaius"
  | "Zapier"
  | "Zendesk";

export type FunctionKey = "Function";

export type StaticDestinationSlug =
  | WarehouseDestinationSlug
  | SaaSDestinationSlug;
export type DestinationSlug = FunctionSlug;
export type DestinationKey =
  | WarehouseDestinationKey
  | SaaSDestinationKey
  | FunctionKey;
export type DestinationName = DestinationKey;

export type SaaSDestinationType =
  | "app"
  | "advertising"
  | "cohorting"
  | "function";
export type WarehouseDestinationType = "warehouse";
export type DestinationType = SaaSDestinationType | WarehouseDestinationType;

export type ConfigFieldEntry = {
  name: string;
  key: string;
  required: boolean;
  description?: React.ReactNode;
  sensitive?: boolean;
  integration_name?: string;
  type?:
    | "boolean"
    | "number"
    | "keyValueList"
    | "list"
    | "select"
    | "radio"
    | "oauth";
  mapControlValueToConfigValue?: (controlValue: any) => any;
  mapConfigValueToControlValue?: (configValue: any) => any;
  enabledIfCheckbox?: string;
  options?: [string, any][] | { value: string; label: string }[]; // For <select>, [Label, Value] -> <option value={Value}>{Label}</option>
  defaultValue?: any;
  placeholder?: string;
  keyValueListLabels?: {
    keyLabel?: string;
    valueLabel?: string;
    objectLabel?: string;
  };
  oauthURL?: (state: string, config: Record<string, any>) => string;
};

export type DestinationAutocompleteMappingEntry = {
  name: string;
  properties?: string[];
};

export type SquareLogoElement = React.ForwardRefExoticComponent<any>;

export type DestinationDataBase = {
  slug: WarehouseDestinationSlug | SaaSDestinationSlug | string; // Used in the URL path
  name: string; // Display name
  key: WarehouseDestinationKey | SaaSDestinationKey | FunctionKey;
  logoSquare: SquareLogoElement;
  hasEventMapping?: boolean;
  supportsTrack: boolean;
  supportsCohorts?: boolean;
  customConfig?: CustomDestinationConfig;
};

export type RequestableSaasDestinationData = {
  slug: WarehouseDestinationSlug | SaaSDestinationSlug; // Used in the URL path
  name: string; // Display name
  logoSquare: SquareLogoElement;
  key: SaaSDestinationKey;
  type: SaaSDestinationType;
};

export type FunctionDestinationData = {
  slug: string;
  name: string;
  config: FunctionConfig;
};

export type SaaSDestinationData = DestinationDataBase & {
  slug: SaaSDestinationSlug | FunctionSlug;
  type: SaaSDestinationType; // 'Advertising', 'App', or 'Cohorting'
  key: SaaSDestinationKey | FunctionKey;

  // docsURL is optional only because we haven't added the URL for each
  // destination yet. In theory every destination should have a docs page.
  docsURL?: string;

  // Determines the default connection mode when setting up a new destination.
  // Note that client-side mode will be disabled when setting this to 'server'.
  connectionMode: DestinationConnectionMode;
  supportsServerSide?: boolean;
  supportsBackfill: boolean;
  supportsMultiConfig?: boolean;
  supportsImpressionPixel?: boolean;
  impressionPixelParams?: Record<string, string>;
  multiConfigLabel?: string;

  configName?: string;
  configHelp: JSX.Element | string;
  configBodyHelp?: JSX.Element | string;
  eventMappingSubheader?: string;
  eventMappingBodyHelp?: JSX.Element | string;
  eventMappingEventName?: string;
  eventMappingConfigKey?: string;
  configFields: ConfigFieldEntry[];

  settingsDescription?: string;
  autocompleteMapping?: DestinationAutocompleteMappingEntry[];
  standardMappingConfig?: DestinationStandardMapping;
  getStandardMapping?: () => Promise<DestinationStandardMapping>;

  defaultValue?: any;

  hasBAA?: boolean;
  isMobileOnly?: boolean;
  isFpEmployeeOnly?: boolean;
  experimental?: boolean;
  supportedSources?: { [K in EventLibrary]?: boolean };
};

export type WarehouseDestinationData = DestinationDataBase & {
  slug: WarehouseDestinationSlug;
  key: WarehouseDestinationKey;
};

export type DestinationStandardMappingItemProperty = {
  key: string;
  type: any;
  description?: string;
  allowedValues?: any[];
  exampleValue?: any;
  additionalTransformation?: {
    operation: TransformationOperationType;
    operandValue?: string;
  };
};

export type DestinationStandardMappingItemBase = {
  propertiesArr: Array<DestinationStandardMappingItemProperty>;
  description?: string;
};

// A normal mapping, like 'AddToCart' event in pinterest
export type DestinationStandardMappingItemNamed = DestinationStandardMappingItemBase & {
  eventName: string;
};

// A customizable mapping for destinations that allows free-form entries
export type DestinationStandardMappingItemWildcard = DestinationStandardMappingItemBase;

// A given config for a destination (like Pinterest) that has standard events with properties
export type DestinationStandardMapping = {
  wildcard: DestinationStandardMappingItemWildcard | null;
  items: Array<DestinationStandardMappingItemNamed>;
};

export enum DestinationConfigModalName {
  ConnectionMode = "connection_mode",
  HIPAA = "hipaa",
  RequiredProperties = "required_properties",
  RecommendedProperties = "recommended_properties",
  RecommendedAttributionProperties = "recommended_attribution_properties",
  RecommendedViewThroughProperties = "recommended_view_through_properties",
  RecommendedUTMProperties = "recommended_utm_properties",
  ConfigureImpressionPixel = "configure_impression_pixel",
}

export type Trace = {
  requestCURL?: string;
  response: {
    body?: any;
    headers?: { [key: string]: string };
    statusCode: number;
    statusMessage: string;
  };
};

export type IngestTraceRow = {
  ID: string;
  EventDefID: string;
  EventDefName: string;
  EventType: string;
  StreamName: string;
  Status: string;
  IsProvisionalStatus: boolean;
  Time: number;
};

export type IPResponse = {
  ip: string;
};

export type DeliveryStatuses = {
  [key: string]: number;
};
